// extracted by mini-css-extract-plugin
export var modal = "_kf-0";